import { MutationOptions, useMutation } from "react-query";
import { API_URL, APIError, APIResponse, post } from "../api";

function useForgotPassword<T>(
  options?: MutationOptions<APIResponse<T>, APIError, Record<any, any>>
) {
  const {
    isLoading,
    isError,
    error,
    mutate: forgotPassword,
  } = useMutation(async (variables: { email: string }) => {
    return await post(API_URL + "/auth/user/forgot-password", variables, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
  }, options);

  return {
    forgotPassword,
    isLoading,
    isError,
    error,
  };
}

export default useForgotPassword;
